"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _BaseSeoManager2 = _interopRequireDefault(require("../BaseSeoManager"));

var _Helmet = require("../meta/Helmet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MANAGER_TYPE = _SeoManagerHelpers.HELPER_MANAGER_TYPE.HUB;
var DEBUG_CONSOLE = false;
var IS_HUBPAGE_LEVEL = 'HubPageLevel';
var IS_AGENCY_LEVEL = 'AgencyLevel';
var IS_HUBPAGE_LEVEL_LAST = 'HubPageLevelLast';
var IS_TRANSACTION_LEVEL = 'TransactionLevel';
var IS_CATEGORY_LEVEL = 'CategoryLevel';
var IS_PROPERTYTYPES_LEVEL = 'PropertyTypeLevel';
var IS_AREAGROUP_LEVEL = 'AreaGroupLevel';
var IS_ROOM_LEVEL = 'RoomLevel';
var IS_PRICE_LEVEL = 'PriceLevel';
var IS_PUBLISHER_LEVEL = 'PublisherLevel';
var IS_FEATURES_LEVEL = 'FeaturesLevel';
var IS_AUCTION_LEVEL = 'isAuctionLevel';
var IS_GEO_LEVEL = 'GeoLevel';
var IS_AREAS_LEVEL = 'AreaLevel';
var IS_REGION_LEVEL = 'RegionLevel';
var IS_PROVINCE_LEVEL = 'ProvinceLevel';
var IS_CITY_LEVEL = 'CityLevel';
var IS_BUILDINDCONDITIONS_LEVEL = 'BuildingConditionLevel';
var CHECK_LEVEL_HUBPAGE_LAST = {
  hubpagelast: true
};
var CHECK_LEVEL_FEATURES = {
  features: true,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_AREA = {
  area: true,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_REGION = {
  region: true,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_PROVINCE = {
  province: true,
  features: CHECK_LEVEL_FEATURES,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_CITY_ZONE = {
  zone: true,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_CITY_OMI = {
  omi: true,
  features: CHECK_LEVEL_FEATURES
};
var CHECK_LEVEL_CITY_ZCI = {
  zci: true,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_CITY_STREET = {
  street: true,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_CITY_AREAGROUP = {
  areagroup: true,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_CITY = {
  zone: CHECK_LEVEL_CITY_ZONE,
  omi: CHECK_LEVEL_CITY_OMI,
  zci: CHECK_LEVEL_CITY_ZCI,
  street: CHECK_LEVEL_CITY_STREET,
  areagroup: CHECK_LEVEL_CITY_AREAGROUP,
  hubpagelast: CHECK_LEVEL_HUBPAGE_LAST
};
var CHECK_LEVEL_PUBLISHER = {
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY,
  features: CHECK_LEVEL_FEATURES
};
var CHECK_LEVEL_PRICE = {
  publisher: CHECK_LEVEL_PUBLISHER,
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY,
  features: CHECK_LEVEL_FEATURES
};
var CHECK_LEVEL_ROOM = {
  price: CHECK_LEVEL_PRICE,
  publisher: CHECK_LEVEL_PUBLISHER,
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY,
  features: CHECK_LEVEL_FEATURES
};
var CHECK_LEVEL_BUILDING_CONDITIONS = {
  room: CHECK_LEVEL_ROOM,
  price: CHECK_LEVEL_PRICE,
  publisher: CHECK_LEVEL_PUBLISHER,
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY,
  features: CHECK_LEVEL_FEATURES
};
var CHECK_LEVEL_PROPERTYTYPES = {
  room: CHECK_LEVEL_ROOM,
  price: CHECK_LEVEL_PRICE,
  publisher: CHECK_LEVEL_PUBLISHER,
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY,
  features: CHECK_LEVEL_FEATURES,
  buildingCondition: CHECK_LEVEL_BUILDING_CONDITIONS
};
var CHECK_LEVEL_CATEGORY = {
  room: CHECK_LEVEL_ROOM,
  price: CHECK_LEVEL_PRICE,
  publisher: CHECK_LEVEL_PUBLISHER,
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY,
  features: CHECK_LEVEL_FEATURES,
  buildingCondition: CHECK_LEVEL_BUILDING_CONDITIONS
};
var CHECK_LEVEL_TRANSACTION = {
  category: CHECK_LEVEL_CATEGORY,
  propertyTypes: CHECK_LEVEL_PROPERTYTYPES,
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY,
  room: CHECK_LEVEL_ROOM,
  price: CHECK_LEVEL_PRICE,
  publisher: CHECK_LEVEL_PUBLISHER,
  features: CHECK_LEVEL_FEATURES,
  buildingCondition: CHECK_LEVEL_BUILDING_CONDITIONS
};
var CHECK_LEVEL_AGENCY = {
  region: CHECK_LEVEL_REGION,
  province: CHECK_LEVEL_PROVINCE,
  area: CHECK_LEVEL_AREA,
  city: CHECK_LEVEL_CITY
};
var CHECK_LEVEL_AUCTION = {
  auction: true
};
var CHECK_LEVEL_HUBPAGE = {
  agency: CHECK_LEVEL_AGENCY,
  auction: CHECK_LEVEL_AUCTION,
  transaction: CHECK_LEVEL_TRANSACTION,
  propertyTypes: CHECK_LEVEL_PROPERTYTYPES
};
var CHECK_LEVEL = {
  hubpage: CHECK_LEVEL_HUBPAGE
};

var HubPagesSeoManager = /*#__PURE__*/function (_BaseSeoManager) {
  _inherits(HubPagesSeoManager, _BaseSeoManager);

  var _super = _createSuper(HubPagesSeoManager);

  function HubPagesSeoManager(domain, lang) {
    var _this;

    _classCallCheck(this, HubPagesSeoManager);

    _this = _super.call(this, domain, lang);
    _this.immotype = undefined;
    _this.encode_parts = {};
    _this.encode_qs = [];
    _this.locations = [];
    _this.num_levels = 0;
    _this.max_levels = 0;
    _this.level_prec = null;
    _this.tree = null;
    return _this;
  }

  _createClass(HubPagesSeoManager, [{
    key: "debugConsole",
    value: function debugConsole(caption, value) {
      if (!DEBUG_CONSOLE) {
        return false;
      }

      console.log('caption', caption);
    }
  }, {
    key: "decodeLevel",
    value: function decodeLevel(level, value) {
      var _this2 = this;

      this.debugConsole("\n* decodeLevel");
      this.debugConsole('level', level);
      this.debugConsole('value', value);

      if (!this.isValidDecode()) {
        return;
      }

      this.valid_levels["level".concat(level)] = false;
      this.level_prec = level === 1 ? null : this.data.seo_decode_type["level".concat(level - 1)];

      var getCheckLevel = function getCheckLevel(dispayValue) {
        _this2.debugConsole('is', dispayValue);

        Object.keys(_this2.data.seo_decode_type).map(function (key, idx) {
          var levelName = _this2.data.seo_decode_type[key];

          if (idx === 0) {
            _this2.tree = Object.assign({}, CHECK_LEVEL[levelName]);
          } else {
            _this2.tree = _this2.tree[levelName];
          }
        });

        if (_this2.tree) {
          _this2.valid_levels["level".concat(level)] = true;
        } else {
          _this2.debugConsole("valid_level_".concat(level), "".concat(_this2.valid_levels["level".concat(level)], ", ").concat(_this2.data.seo_decode_type["level".concat(level)]));
        }
      };

      if (this.isHubPageLevel(value, level)) {
        getCheckLevel(IS_HUBPAGE_LEVEL);
      } else if (this.isAgencyLevel(value, level)) {
        getCheckLevel(IS_AGENCY_LEVEL);
      } else if (this.isAuctionLevel(value, level)) {
        getCheckLevel(IS_AUCTION_LEVEL);
      } else if (this.isTransactionLevel(value, level)) {
        getCheckLevel(IS_TRANSACTION_LEVEL);
      } else if (this.isCategoryLevel(value, level)) {
        getCheckLevel(IS_CATEGORY_LEVEL);
      } else if (this.isPropertyTypeLevel(value, level)) {
        getCheckLevel(IS_PROPERTYTYPES_LEVEL);
      } else if (this.isBuildingConditionLevel(value, level)) {
        getCheckLevel(IS_BUILDINDCONDITIONS_LEVEL);
      } else if (this.isAreaGroupLevel(value, level)) {
        getCheckLevel(IS_AREAGROUP_LEVEL);
      } else if (this.isRoomLevel(value, level)) {
        getCheckLevel(IS_ROOM_LEVEL);
      } else if (this.isPriceLevel(value, level)) {
        getCheckLevel(IS_PRICE_LEVEL);
      } else if (this.isPublisherLevel(value, level)) {
        getCheckLevel(IS_PUBLISHER_LEVEL);
      } else if (this.isFeaturesLevel(value, level)) {
        getCheckLevel(IS_FEATURES_LEVEL);
      } else if (this.isHubPageLastLevel(value, level)) {
        getCheckLevel(IS_HUBPAGE_LEVEL_LAST);
      } else if (this.isGeoLevel(value, level)) {
        if (this.valid_geo_levels["level".concat(level)]) {
          getCheckLevel(IS_GEO_LEVEL);
        }
      }

      this.debugConsole("valid_level_".concat(level), "".concat(this.valid_levels["level".concat(level)], "\n"));
    }
  }, {
    key: "isHubPageLevel",
    value: function isHubPageLevel(value, level) {
      if (value === 'liste') {
        this.addData('liste', value);
        this.addDecodeData("level".concat(level), 'hubpage');
        return true;
      }

      return false;
    }
  }, {
    key: "isAgencyLevel",
    value: function isAgencyLevel(value, level) {
      if (value === 'agenzie') {
        this.addData('agency', value);
        this.addDecodeData("level".concat(level), 'agency');
        return true;
      }

      return false;
    }
  }, {
    key: "isAuctionLevel",
    value: function isAuctionLevel(value, level) {
      if (value === 'aste') {
        this.addData('auction', value);
        this.addDecodeData("level".concat(level), 'auction');
        return true;
      }

      return false;
    }
  }, {
    key: "isHubPageLastLevel",
    value: function isHubPageLastLevel(value, level) {
      if (value === 'comuni') {
        this.addData('comuni', value);
        this.addDecodeData("level".concat(level), 'hubpagelast');
        return true;
      }

      return false;
    }
  }, {
    key: "isTransactionLevel",
    value: function isTransactionLevel(value, level) {
      if (_SeoManagerHelpers.TR_DECODE_FOR_ESAPI[this.lang][value] !== undefined) {
        this.addData('tr', _SeoManagerHelpers.TR_DECODE_FOR_ESAPI[this.lang][value]);
        this.addDecodeData("level".concat(level), 'transaction');
        return true;
      }

      return false;
    }
  }, {
    key: "isCategoryLevel",
    value: function isCategoryLevel(value, level) {
      if (_SeoManagerHelpers.CAT_DECODE_FOR_ESAPI[this.lang][value]) {
        this.addData('category', _SeoManagerHelpers.CAT_DECODE_FOR_ESAPI[this.lang][value]);
        this.addDecodeData("level".concat(level), 'category');
        return true;
      }

      return false;
    }
  }, {
    key: "isPropertyTypeLevel",
    value: function isPropertyTypeLevel(value, level) {
      if (this.level_prec === 'city') {
        return false;
      }

      var obj = (0, _SeoManagerHelpers.getObjByCategoryImmotype)(this.lang, value);

      if (obj) {
        this.immotype = obj;
        this.addData('propertyTypes', obj);
        this.addData('category', obj.category);
        this.addDecodeData("level".concat(level), 'propertyTypes');
        return true;
      }

      if (!this.data.category && (!this.data || !this.data.agency)) {
        this.addData('category', _SeoManagerHelpers.DEFAULT_CATEGORY);
      }

      return false;
    }
  }, {
    key: "isBuildingConditionLevel",
    value: function isBuildingConditionLevel(value, level) {
      var buildingConds = (0, _SeoManagerHelpers.getBuildingConditions)(this.lang, value);

      if (buildingConds) {
        this.addData('buildingCondition', buildingConds);
        this.addDecodeData("level".concat(level), 'buildingCondition');
        return true;
      }

      return false;
    }
  }, {
    key: "decodeGeoType",
    value: function decodeGeoType(value, level, geoLevel) {
      var geoType = (0, _SeoManagerHelpers.decodeGeoType)(value, level);
      var geo = Object.assign({}, geoType.geo);
      var dgeo = Object.assign({}, geoType.dgeo);

      if (geo.type === geoLevel) {
        this.addDecodeData("level".concat(level), geo.type);
        this.addData('geo', dgeo);

        if (geoType.valid_levels && Object.keys(geoType.valid_levels).length > 0 && Object.keys(geoType.valid_levels).map(function (k) {
          return !geoType.valid_levels[k] ? k : null;
        }).filter(Boolean).length > 0) {
          return false;
        }

        return true;
      }

      return false;
    }
  }, {
    key: "isGeoLevel",
    value: function isGeoLevel(value, level) {
      if (this.isAreaGroupLevel(value, level)) {
        this.debugConsole('geo', IS_AREAGROUP_LEVEL);
        return true;
      } else if (this.isRegionLevel(value, level)) {
        this.debugConsole('geo', IS_REGION_LEVEL);
        return true;
      } else if (this.isProvinceLevel(value, level)) {
        this.debugConsole('geo', IS_PROVINCE_LEVEL);
        return true;
      } else if (this.isCityLevel(value, level)) {
        this.debugConsole('geo', IS_CITY_LEVEL);
        return true;
      }

      return false;
    }
  }, {
    key: "isAreaGroupLevel",
    value: function isAreaGroupLevel(value, level) {
      this.valid_geo_levels["level".concat(level)] = true;
      var res = this.decodeGeoType(value, level, _SeoManagerHelpers.GEO_TYPE_AREAGROUP);

      if (!res) {
        this.valid_levels["level".concat(level)] = false;
        this.valid_geo_levels["level".concat(level)] = false;
      }

      return res;
    }
  }, {
    key: "isRegionLevel",
    value: function isRegionLevel(value, level) {
      this.valid_geo_levels["level".concat(level)] = true;
      var res = this.decodeGeoType(value, level, _SeoManagerHelpers.GEO_TYPE_REGION);

      if (!res) {
        this.valid_levels["level".concat(level)] = false;
        this.valid_geo_levels["level".concat(level)] = false;
      }

      return res;
    }
  }, {
    key: "isProvinceLevel",
    value: function isProvinceLevel(value, level) {
      this.valid_geo_levels["level".concat(level)] = true;
      var res = this.decodeGeoType(value, level, _SeoManagerHelpers.GEO_TYPE_PROVINCE);

      if (!res) {
        this.valid_levels["level".concat(level)] = false;
        this.valid_geo_levels["level".concat(level)] = false;
      }

      return res;
    }
  }, {
    key: "isCityLevel",
    value: function isCityLevel(value, level) {
      this.valid_geo_levels["level".concat(level)] = true;

      if (this.level_prec === 'city') {
        var _res = this.isAreeLevel(value, level);

        this.debugConsole('city', "".concat(IS_AREAS_LEVEL, ": ").concat(_res));
        return _res;
      }

      var res = this.decodeGeoType(value, level, _SeoManagerHelpers.GEO_TYPE_CITY);

      if (!res) {
        this.valid_levels["level".concat(level)] = false;
        this.valid_geo_levels["level".concat(level)] = false;
      }

      return true;
    }
  }, {
    key: "isRoomLevel",
    value: function isRoomLevel(value, level) {
      var rooms = (0, _SeoManagerHelpers.getRooms)(value);

      if (rooms[0]) {
        this.addData('rooms', rooms[0]);
        this.addData('isRoomsNumber', rooms[1]);
        this.addDecodeData("level".concat(level), 'room');
        return true;
      }

      return false;
    }
  }, {
    key: "isPriceLevel",
    value: function isPriceLevel(value, level) {
      var price = (0, _SeoManagerHelpers.getPrice)(value);

      if (price) {
        this.addData('price', price);
        this.addDecodeData("level".concat(level), 'price');
        return true;
      }

      return false;
    }
  }, {
    key: "isPublisherLevel",
    value: function isPublisherLevel(value, level) {
      var publisher = (0, _SeoManagerHelpers.getPublisher)(value);

      if (publisher) {
        this.addData('publisher', publisher);
        this.addDecodeData("level".concat(level), 'publisher');
        return true;
      }

      return false;
    }
  }, {
    key: "isAreeLevel",
    value: function isAreeLevel(value, level) {
      this.debugConsole('aree', "".concat(IS_AREAS_LEVEL, ": ").concat(JSON.stringify(this.data.geo)));
      var dgeo = this.data.geo;
      var geo = (0, _SeoManagerHelpers.decodeAree)(value);
      dgeo.l10 = _defineProperty({}, geo.type, geo.level1);
      this.addDecodeData("level".concat(level), geo.type);
      this.addData('geo', dgeo);
      return true;
    }
  }, {
    key: "isFeaturesLevel",
    value: function isFeaturesLevel(value, level) {
      var _this3 = this;

      var match;
      var REGEXP_GARDEN_TYPE = new RegExp(/^giardino[+-](comune|privato)$/gi);
      var REGEXP_HEATIG_TYPE = new RegExp(/^riscaldamento[+-](autonomo|centralizzato)$/gi);
      var REGEXP_LIFT_LEVEL = new RegExp(/^ascensore-se-almeno-([1-5])-piano$/gi);
      var REGEXP_BOX = new RegExp(/box[+-]post([oi])[+-]auto?|post([oi])[+-]auto?|box$/gi);
      var REGEXP_PUBLISHER_LEVEL = new RegExp(/^da[+-](agenzie|privati|costruttori)$/gi);

      var convertFeaturesToFilters = function convertFeaturesToFilters(features) {
        var qo = {};
        features.map(function (feature) {
          switch (feature) {
            case 'giardino':
              qo.garden = ['comune', 'privato'];
              break;

            case String(feature.match(REGEXP_GARDEN_TYPE)):
              REGEXP_GARDEN_TYPE.lastIndex = 0;
              match = REGEXP_GARDEN_TYPE.exec(feature);
              qo.garden = match[1];
              break;

            case 'balcone':
              qo.balcony = true;
              break;

            case 'terrazzo':
              qo.terrace = true;
              break;

            case 'riscaldamento':
              qo.heatingType = ['autonomo', 'centralizzato'];
              break;

            case String(feature.match(REGEXP_HEATIG_TYPE)):
              REGEXP_HEATIG_TYPE.lastIndex = 0;
              match = REGEXP_HEATIG_TYPE.exec(feature);
              qo.heatingType = match[1];
              break;

            case 'foto':
              qo.photo = true;
              break;

            case 'ascensore':
              qo.lift = true;
              break;

            case String(feature.match(REGEXP_LIFT_LEVEL)):
              REGEXP_LIFT_LEVEL.lastIndex = 0;
              match = REGEXP_LIFT_LEVEL.exec(feature);
              qo.lift = match[1];
              break;

            case String(feature.match(REGEXP_BOX)):
              REGEXP_BOX.lastIndex = 0;
              match = REGEXP_BOX.exec(feature);
              qo.numParkingSpaces = 1;
              break;

            case String(feature.match(REGEXP_PUBLISHER_LEVEL)):
              REGEXP_PUBLISHER_LEVEL.lastIndex = 0;
              match = REGEXP_PUBLISHER_LEVEL.exec(feature);

              _this3.addData('publisher', match[1]);

            case 'asta-immobiliare':
              qo.only_auction = true;
              break;
              break;

            default:
              break;
          }
        });
        return qo;
      };

      var features = (0, _SeoManagerHelpers.getFeatures)(value);

      if (features) {
        this.addData('features', features);
        this.addDecodeData("level".concat(level), 'features');
        this.data.queryObject = Object.assign({}, this.data.queryObject || null, convertFeaturesToFilters(features));
        return true;
      }

      return false;
    }
  }, {
    key: "createSeoData",
    value: function createSeoData() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locations = _ref.locations,
          total_listings = _ref.total_listings,
          seoParams = _ref.seoParams,
          isSrpUrl = _ref.isSrpUrl;

      this.seo_data.seo = (0, _Helmet.getHelmet)({
        domain: this.domain,
        lang: this.lang,
        seodata: this.data,
        locations: locations,
        count: total_listings,
        seoParams: seoParams,
        pageType: 'HubPage',
        isSrpUrl: isSrpUrl
      });
    }
  }], [{
    key: "getLevel1Slug",
    value: function getLevel1Slug() {
      return {
        type: MANAGER_TYPE,
        regexp: ['liste']
      };
    }
  }]);

  return HubPagesSeoManager;
}(_BaseSeoManager2["default"]);

var _default = HubPagesSeoManager;
exports["default"] = _default;